import { render, staticRenderFns } from "./ProjetoContainer.vue?vue&type=template&id=e8791034&scoped=true"
import script from "./ProjetoContainer.vue?vue&type=script&lang=js"
export * from "./ProjetoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8791034",
  null
  
)

export default component.exports